<template>
  <div class="dashboard-container">
    <!-- 头部 -->
    <header class="dashboard-header">
      <div class="title-box">
        <h1>外贸客户信息管理系统</h1>
        <p>后台数据总览 | 实时更新</p>
      </div>
      <div class="header-actions">
        <button class="refresh-btn" @click="refreshData">刷新数据</button>
      </div>
    </header>

    <!-- 第一部分：核心数据卡片 -->
    <section class="core-card-wrapper">
      <div class="core-card" v-for="item in coreData" :key="item.title">
        <div class="card-icon" :style="{ backgroundColor: item.iconBg }">
          <i class="card-icon-inner iconfont" v-html="item.icon"></i>
        </div>
        <div class="card-content">
          <h4>{{ item.title }}</h4>
          <div class="card-number">{{ item.value }}</div>
          <div class="card-change" :class="{ up: item.growth > 0, down: item.growth < 0 }">
            {{ item.growth > 0 ? '↑' : '↓' }} {{ Math.abs(item.growth).toFixed(2) }}% {{ item.tip }}
          </div>
        </div>
      </div>
    </section>

    <!-- 第二部分：双图表区域（彻底修复溢出） -->
    <section class="double-chart-wrapper">
      <div class="chart-box pie-box">
        <h3>客户来源分析</h3>
        <div class="chart-container">
          <div id="sourceChart" class="chart-content"></div>
        </div>
      </div>
      <div class="chart-box line-box">
        <h3>跟进/成交客户数月度趋势</h3>
        <div class="chart-container">
          <div id="trendChart" class="chart-content"></div>
        </div>
      </div>
    </section>

    <!-- 第六部分：其他公司数据（待办默认显示今日、支持日期筛选）【修改点2：原辅助卡片位置替换为最新订单】 -->
    <section class="other-data-wrapper">
      <h3 style="margin-bottom: 15px;">公司业务辅助数据面板<span class="other-data-wrapper-btn iconfont" style="float: right;"
          @click="jumpToPage('产品订单管理')">管理订单 &#xEA6E;</span></h3>
      <div class="data-panel">
        <!-- 最新订单进度（10条）【移到此处】 -->
        <div class="latest-order-wrapper" style="overflow-y: auto;">
          <!-- <h3>最新订单进度（10条）</h3> -->
          <div class="order-list">
            <div class="order-item" v-for="order in latestOrders" :key="order.id" @click="jumpToFuc(order.id)">
              <div class="order-left">
                <div class="order-no">{{ order.oid }}</div>
                <div class="order-base">
                  <span>客户：{{ order?.cusInfo?.name || '无客户信息' }}</span>
                  <span>销售：{{ order?.account?.nickname || '无销售信息' }}</span>
                  <!-- <span>金额：{{ order.amount }}</span> -->
                </div>
              </div>
              <div class="order-right">
                <div class="order-progress">
                  <div class="progress-bg" v-show="order.state != 8">
                    <div class="progress-fill" v-show="order.state != 8"
                      :style="{ width: (order.state / 7 * 100).toFixed(2) + '%', backgroundColor: getProgressColor(order.state / 7 * 100) }">
                    </div>
                  </div>
                  <span class="progress-text">{{ order.state != 8 ? (order.state / 7 * 100).toFixed(2) + '%' : '订单已取消'
                  }}</span>
                  <span class="iconfont" v-show="order.state == 8" style="color: red;">&#xEB96;</span>
                </div>
                <div class="order-update">{{ order.updateTime }}</div>
              </div>
            </div>
          </div>
        </div>

        <!-- 原右侧待办+客户等级【保持不变】 -->
        <div class="panel-right">
          <div class="todo-list">
            <div class="todo-top">
              <h4>待办事项（紧急）</h4>
              <el-date-picker v-model="todoSelectedDate" type="date" placeholder="选择查询日期" format="yyyy-MM-dd"
                value-format="yyyy-MM-dd" size="small" class="todo-date-picker"
                @change="filterTodoByDate"></el-date-picker>
              <!-- <el-date-picker v-model="todoSelectedDate" type="date" placeholder="选择日期">
              </el-date-picker> -->
            </div>
            <ul>
              <li v-for="todo in filteredTodoList" :key="todo.id">
                <input type="checkbox" v-model="todo.completed">
                <span class="todo-content" :class="{ completed: todo.completed }">{{ todo.content }}</span>
                <span class="todo-deadline">{{ todo.deadline }}</span>
              </li>
              <!-- 无数据提示 -->
              <li v-if="filteredTodoList.length === 0" class="no-todo-tip">
                该日期暂无待办事项
              </li>
            </ul>
          </div>
          <div class="customer-level">
            <h4>客户等级分布</h4>
            <div id="levelChart" class="level-chart-content"></div>
          </div>
        </div>
      </div>
    </section>

    <!-- 第三部分：日程组件（彻底修复星期与日期错位） -->
    <section class="schedule-wrapper" style="margin-top: 20px;">
      <div class="schedule-header">
        <h3>客户跟进日程管理</h3>
        <div class="date-picker">
          <button @click="prevWeek">« 上一周</button>
          <span class="date-range-text">{{ dateRangeStart }} 至 {{ dateRangeEnd }}</span>
          <button @click="nextWeek">下一周 »</button>
        </div>
      </div>
      <div class="schedule-calendar">
        <div class="calendar-header">
          <div class="calendar-day" v-for="(day, idx) in calendarDays" :key="idx">
            {{ day }}
          </div>
        </div>
        <div class="calendar-content">
          <div class="calendar-column" v-for="(col, index) in 7" :key="index">
            <div class="calendar-date" :class="{ active: isCurrentDate(index) }">
              {{ getCalendarFullDate(index) }}
            </div>
            <div class="schedule-item" v-for="schedule in getScheduleByColumn(index)" :key="schedule.id"
              @click="jumpToFuc(schedule?.oid)">
              <div class="item-order">订单：{{ schedule.orderId }}</div>
              <div class="item-person">
                <span>销售：{{ schedule?.account?.nickname }}</span>
                <span>客户：{{ schedule.cusInfo?.name }}</span>
              </div>
              <div class="item-content" v-html="schedule?.mess"></div>
              <div class="item-time">{{ initTimeFuc(schedule?.ctime) }}</div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 第四、五部分：横向并排（无溢出）【修改点1：原最新订单位置替换为辅助卡片】 -->
    <section class="horizontal-combo-wrapper" v-show="false">
      <!-- 原公司业务辅助数据面板左侧4个卡片【移到此处】 -->
      <section class="assist-card-wrapper">
        <h3>公司业务辅助数据</h3>
        <div class="panel-left">
          <div class="assist-card" v-for="card in assistCards" :key="card.title">
            <h4>{{ card.title }}</h4>
            <div class="assist-value">{{ card.value }}</div>
            <div class="assist-change" :class="{ positive: card.change > 0, negative: card.change < 0 }">
              {{ card.change > 0 ? '+' : '' }}{{ card.change }}% 较上月
            </div>
          </div>
        </div>
      </section>

      <!-- 本月业务进度【保持不变】 -->
      <section class="business-progress-wrapper">
        <h3>本月业务进度完成情况</h3>
        <div class="business-chart-box">
          <div id="businessChart" class="business-chart-content"></div>
          <div class="business-desc">
            <div class="desc-item" v-for="item in businessDesc" :key="item.name">
              <span class="desc-color" :style="{ backgroundColor: item.color }"></span>
              <span class="desc-name">{{ item.name }}</span>
              <span class="desc-value">{{ item.value }} ({{ item.rate }}%)</span>
            </div>
          </div>
        </div>
      </section>
    </section>


  </div>
</template>

<script>
import * as echarts from 'echarts';
// 局部引入ElementUI组件和必要样式
import { homeData, homeMess } from '@/api';
import { jumpTo, initTime } from '@/utils/myutils';
export default {
  components: {},
  data() {
    return {
      // 日期相关（周日~周六，彻底对齐核心）
      currentWeek: 0,
      calendarDays: ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
      // 日程数据
      scheduleList: [],
      // 最新订单
      latestOrders: [],
      // 业务进度描述
      businessDesc: [
        { name: '已完成', value: '65单', rate: 65, color: '#67C23A' },
        { name: '进行中', value: '20单', rate: 20, color: '#409EFF' },
        { name: '未开始', value: '15单', rate: 15, color: '#E6A23C' }
      ],
      // 辅助数据卡片
      assistCards: [
        { title: '本月回款总额', value: '$289,600', change: 12.3 },
        { title: '未回款订单数', value: '17', change: -5.6 },
        { title: '高价值客户数', value: '23', change: 8.1 },
        { title: '客户流失率', value: '2.8%', change: -1.2 }
      ],
      // 待办事项（新增todoDate字段，用于日期筛选）
      todoList: [
        { id: 1, content: '跟进ABC客户大额订单回款', deadline: '2026-02-18', completed: false, todoDate: '2026-02-09' },
        { id: 2, content: '整理上月展会客户资料', deadline: '2026-02-10', completed: false, todoDate: '2026-02-09' },
        { id: 3, content: '更新产品报价单给XYZ客户', deadline: '2026-02-16', completed: true, todoDate: '2026-02-10' },
        { id: 4, content: '参加部门月度业务总结会', deadline: '2026-02-19', completed: false, todoDate: '2026-02-09' },
        { id: 5, content: '跟进售后反馈的客户质量问题', deadline: '2026-02-17', completed: false, todoDate: '2026-02-10' },
        { id: 4, content: '参加部门月度业务总结会', deadline: '2026-02-9', completed: false, todoDate: '2026-02-09' },
        { id: 5, content: '跟进售后反馈的客户质量问题', deadline: '2026-02-17', completed: false, todoDate: '2026-02-09' },
        { id: 4, content: '参加部门月度业务总结会', deadline: '2026-02-9', completed: false, todoDate: '2026-02-09' },
        { id: 5, content: '跟进售后反馈的客户质量问题', deadline: '2026-02-17', completed: false, todoDate: '2026-02-09' }
      ],
      todoSelectedDate: '', // 待办选中日期（默认今日）
      // ECharts实例
      sourceChart: null,
      trendChart: null,
      businessChart: null,
      levelChart: null,
      homeOptions: {}
    };
  },
  computed: {
    // 核心卡片数据
    coreData() {
      return [
        { title: '客户总数', value: this.homeOptions?.countAll, growth: this.homeOptions?.lastCountAll == 0 ? 100 : (this.homeOptions?.countAll - this.homeOptions?.lastCountAll) / this.homeOptions?.lastCountAll * 100, icon: '&#xF25C;', iconBg: '#67C23A', 'tip': '用户增长率' },
        { title: '本月新增客户', value: this.homeOptions?.countAll - this.homeOptions?.lastCountAll, growth: this.homeOptions?.addCount2 == 0 ? 100 : (this.homeOptions?.addCount - this.homeOptions?.addCount2) / this.homeOptions?.addCount2 * 100, icon: '&#xF26C;', iconBg: '#409EFF', 'tip': '较上月同期' },
        { title: '跟进中订单数', value: this.homeOptions?.jxOrder, growth: (this.homeOptions?.jxOrder) / this.homeOptions?.countOrdersAll * 100, icon: '&#xED0F;', iconBg: '#E6A23C', 'tip': '进行中订单占比' },
        { title: '本月完结订单数', value: this.homeOptions?.countEndOrders, growth: this.homeOptions?.countLastEndOrders == 0 ? 100 : (this.homeOptions?.countEndOrders - this.homeOptions?.countLastEndOrders) / this.homeOptions?.countLastEndOrders * 100, icon: '&#xF438;', iconBg: '#909399', 'tip': '较上月同期' }
      ];
    },
    // 日期范围开始（完整格式）
    dateRangeStart() {
      const weekFirstDay = this.getWeekFirstDay();
      return this.formatToFullDate(weekFirstDay);
    },
    // 日期范围结束（完整格式）
    dateRangeEnd() {
      const weekFirstDay = this.getWeekFirstDay();
      const weekLastDay = new Date(weekFirstDay.getTime() + 6 * 24 * 60 * 60 * 1000);
      return this.formatToFullDate(weekLastDay);
    },
    // 筛选后的待办列表（默认今日）
    filteredTodoList() {
      if (!this.todoSelectedDate) return [];
      return this.todoList.filter(todo => todo.todoDate === this.todoSelectedDate);
    }
  },
  mounted() {
    // 初始化今日日期
    this.todoSelectedDate = this.formatToFullDate(new Date());
    this.initMockData();
    this.homeDataFuc();
    this.homeMessFuc();
    this.$nextTick(() => {
      this.initECharts();
      // 绑定resize事件，强制适配容器，彻底解决溢出
      window.addEventListener('resize', this.forceRefreshCharts);
    });
  },
  beforeDestroy() {
    // 销毁图表释放内存
    if (this.sourceChart) this.sourceChart.dispose();
    if (this.trendChart) this.trendChart.dispose();
    if (this.businessChart) this.businessChart.dispose();
    if (this.levelChart) this.levelChart.dispose();
    // 移除resize事件
    window.removeEventListener('resize', this.forceRefreshCharts);
  },
  methods: {
    initTimeFuc(time) {
      return initTime(time);
    },
    refreshData() {
      window.location.reload();
    },
    jumpToPage(n, p, q) {
      jumpTo(this, n, p || {}, q || {});
    },
    jumpToFuc(id) {
      jumpTo(this, "订单详情", { id: id }, {});
    },
    async homeMessFuc() {
      const loading = this.$loading({
        lock: true,
        text: '加载中...',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      const data = await homeMess({
        'from': new Date(this.dateRangeStart + ' 00:00:00').getTime(),
        'to': new Date(this.dateRangeEnd + ' 23:59:59').getTime()
      });
      loading.close();
      if (data.code === 200) {
        this.scheduleList = data.data;
      } else {
        this.$message.error(data.message);
      }
    },
    async homeDataFuc() {
      const res = await homeData();
      if (res.code === 200) {
        this.homeOptions = res;
        const t = [];
        res.srceCountVOS.forEach(item => {
          t.push({
            value: item.recordCount, name: ['阿里巴巴', '中国制造', '独立站', '公司展会', '集团客户', '亚马逊', '脸书', '广交会', '环球资源', '社交媒体', '速卖通',
              '其他来源'][item.srce], itemStyle: { color: ['#67C23A', '#409EFF', '#E6A23C', '#909399', '#303133', '#FF9900', '#FF6600', '#CC3300', '#993300', '#663300', '#333300', '#000000'][item.srce] }
          })
        });
        this.sourceChart.setOption({
          series: [
            {
              data: t
            }
          ]
        });
        console.log(res.userMonthCounts.map(item => item.newUserCount));
        console.log(res.orderMonthCounts.map(item => item.newOrderCount));
        console.log(res.userMonthCounts.map(item => item.monthStr));

        this.trendChart.setOption({
          series: [
            {
              name: '跟进客户数',
              type: 'line',
              data: res.userMonthCounts.map(item => item.newUserCount),
              lineStyle: { color: '#67C23A' },
              itemStyle: { color: '#67C23A' },
              areaStyle: { color: 'rgba(103, 194, 58, 0.1)' }
            },
            {
              name: '成交客户数',
              type: 'line',
              data: res.orderMonthCounts.map(item => item.newOrderCount),
              lineStyle: { color: '#409EFF' },
              itemStyle: { color: '#409EFF' },
              areaStyle: { color: 'rgba(64, 158, 255, 0.1)' }
            }
          ],
          xAxis: {
            type: 'category',
            data: res.orderMonthCounts.map(item => item.monthStr),
            axisLine: { lineStyle: { color: '#e0e0e0' } },
            axisLabel: { color: '#333' }
          }
        });
        res.orderMonthCounts.map(item => item.monthStr);

        this.latestOrders = res.shopOrders;

        this.levelChart.setOption({
          series: [{
            name: '客户数',
            type: 'bar',
            data: [res.customerRatingCount?.rating0Count, res.customerRatingCount?.rating1Count, res.customerRatingCount?.rating2Count, res.customerRatingCount?.rating3Count, res.customerRatingCount?.rating4Count],
            itemStyle: {
              color: (params) => {
                const colors = ['#67C23A', '#409EFF', '#E6A23C', '#F56C6C', '#909399'];
                return colors[params.dataIndex];
              }
            },
            barWidth: '40%'
          }]
        });
      } else {
        this.$message.error(res.message);
      }
    },
    // 工具方法：日期格式化为yyyy-MM-dd
    formatToFullDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    // 核心：获取当前周的第一天（周日），彻底解决星期错位
    getWeekFirstDay() {
      const now = new Date();
      // 计算当前日期距离本周日的偏移量（0=周日，1=周一...6=周六）
      const offset = now.getDay();
      // 本周日的时间戳（当前时间 - 偏移量天）
      const weekFirstDayTimestamp = now.getTime() - offset * 24 * 60 * 60 * 1000;
      // 加上周数偏移（切换上/下一周）
      const targetTimestamp = weekFirstDayTimestamp - this.currentWeek * 7 * 24 * 60 * 60 * 1000;
      return new Date(targetTimestamp);
    },
    // 强制刷新图表（彻底解决溢出，获取容器实际尺寸）
    forceRefreshCharts() {
      if (this.sourceChart) {
        const sourceContainer = document.getElementById('sourceChart').parentNode;
        this.sourceChart.resize({
          width: sourceContainer.offsetWidth - 30, // 减去内边距，避免溢出
          height: 280
        });
      }
      if (this.trendChart) {
        const trendContainer = document.getElementById('trendChart').parentNode;
        this.trendChart.resize({
          width: trendContainer.offsetWidth - 30,
          height: 280
        });
      }
      if (this.businessChart) this.businessChart.resize({ width: 'auto', height: 'auto' });
      if (this.levelChart) this.levelChart.resize({ width: 'auto', height: 'auto' });
    },
    // 上一周
    prevWeek() {
      this.currentWeek += 1;
      this.$nextTick(() => {
        this.homeMessFuc();
      });
    },
    // 下一周
    nextWeek() {
      if (this.currentWeek <= 0) return;
      this.currentWeek -= 1;
      this.$nextTick(() => {
        this.homeMessFuc();
      });
    },
    // 核心：获取完整日历日期（星期与日期严格对齐）
    getCalendarFullDate(index) {
      const weekFirstDay = this.getWeekFirstDay();
      // 每个索引对应本周的第index天（0=周日，1=周一...6=周六）
      const targetDate = new Date(weekFirstDay.getTime() + index * 24 * 60 * 60 * 1000);
      return this.formatToFullDate(targetDate);
    },
    // 判断是否为当前日期
    isCurrentDate(index) {
      const today = this.formatToFullDate(new Date());
      const calendarDate = this.getCalendarFullDate(index);
      return calendarDate === today && this.currentWeek === 0;
    },
    // 按列筛选日程（严格对齐）
    getScheduleByColumn(index) {
      const targetDate = this.getCalendarFullDate(index);
      console.log(targetDate);
      return this.scheduleList.filter(item => item.ctime.startsWith(targetDate));
    },
    // 待办日期筛选（触发刷新）
    filterTodoByDate() {
      // 选中日期后自动筛选，无需额外逻辑，依赖computed属性
    },
    // 获取进度条颜色
    getProgressColor(progress) {
      if (progress >= 100) return '#67C23A';
      if (progress >= 50) return '#409EFF';
      if (progress >= 20) return '#E6A23C';
      return '#F56C6C';
    },
    // 初始化模拟数据
    initMockData() {
      // 日程数据（完整yyyy-MM-dd格式，与日历对齐）
      const today = this.formatToFullDate(new Date());
      const yesterday = this.formatToFullDate(new Date(Date.now() - 24 * 60 * 60 * 1000));
      const beforeYesterday = this.formatToFullDate(new Date(Date.now() - 2 * 24 * 60 * 60 * 1000));
      // this.scheduleList = [
      //   { id: 1, orderNo: 'ORD20260205001', salesman: '张三', customer: 'ABC Trading Co., Ltd', content: '跟进产品报价，客户要求降低5%单价', createTime: '09:30', date: today },
      //   { id: 2, orderNo: 'ORD20260205002', salesman: '李四', customer: 'XYZ Import LLC', content: '确认订单发货时间，预计3个工作日内发出', createTime: '14:20', date: today },
      //   { id: 3, orderNo: 'ORD20260204001', salesman: '王五', customer: '123 Business Group', content: '客户反馈货物质量问题，已安排售后', createTime: '16:50', date: yesterday },
      //   { id: 4, orderNo: 'ORD20260203001', salesman: '张三', customer: 'ABC Trading Co., Ltd', content: '签订新订单，金额$15,000', createTime: '10:10', date: beforeYesterday },
      //   { id: 5, orderNo: 'ORD20260201001', salesman: '孙七', customer: '789 Global Trading', content: '修改订单规格，同步生产部门', createTime: '15:20', date: this.formatToFullDate(new Date(Date.now() - 4 * 24 * 60 * 60 * 1000)) }
      // ];

      // 最新订单数据
      // this.latestOrders = [];
      // for (let i = 1; i <= 10; i++) {
      //   this.latestOrders.push({
      //     id: i,
      //     orderNo: `ORD2026020${i < 10 ? '0' + i : i}00${i}`,
      //     customer: [`ABC Trading Co., Ltd`, `XYZ Import LLC`, `123 Business Group`][Math.floor(Math.random() * 3)],
      //     salesman: [`张三`, `李四`, `王五`][Math.floor(Math.random() * 3)],
      //     amount: `$${Math.floor(Math.random() * 50 + 10)},${Math.floor(Math.random() * 900 + 100)}`,
      //     progress: Math.floor(Math.random() * 100),
      //     updateTime: `2026-02-0${Math.floor(Math.random() * 5 + 1)} ${Math.floor(Math.random() * 20 + 8)}:${Math.floor(Math.random() * 50 + 10)}`
      //   });
      // }
    },
    // 初始化ECharts（绑定容器实际尺寸，无溢出）
    initECharts() {
      // 1. 客户来源饼图
      const sourceContainer = document.getElementById('sourceChart').parentNode;
      this.sourceChart = echarts.init(document.getElementById('sourceChart'));
      this.sourceChart.setOption({
        backgroundColor: '#fff',
        tooltip: { trigger: 'item', formatter: '{b}: {c} ({d}%)' },
        legend: { orient: 'vertical', left: '10%', top: 'center', textStyle: { color: '#333' } },
        series: [{
          name: '来源',
          type: 'pie',
          radius: ['30%', '70%'],
          center: ['60%', '50%'],
          data: [
            { value: 356, name: '阿里巴巴国际站', itemStyle: { color: '#67C23A' } },
            { value: 289, name: '环球资源', itemStyle: { color: '#85CE61' } },
            { value: 218, name: '展会拓展', itemStyle: { color: '#A0D995' } },
            { value: 196, name: '老客户推荐', itemStyle: { color: '#B5E8A0' } },
            { value: 227, name: '其他渠道', itemStyle: { color: '#C6F7E2' } }
          ],
          label: { show: false },
          emphasis: { label: { show: true, color: '#333', fontSize: 14 } }
        }]
      });
      this.sourceChart.resize({ width: sourceContainer.offsetWidth - 30, height: 280 });

      // 2. 跟进/成交折线图
      const trendContainer = document.getElementById('trendChart').parentNode;
      this.trendChart = echarts.init(document.getElementById('trendChart'));
      this.trendChart.setOption({
        backgroundColor: '#fff',
        tooltip: { trigger: 'axis' },
        legend: { data: ['跟进客户数', '成交客户数'], textStyle: { color: '#333' }, top: '0%' },
        grid: { left: '5%', right: '5%', bottom: '10%', top: '15%', containLabel: true },
        xAxis: {
          type: 'category',
          data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
          axisLine: { lineStyle: { color: '#e0e0e0' } },
          axisLabel: { color: '#333' }
        },
        yAxis: {
          type: 'value',
          axisLine: { lineStyle: { color: '#e0e0e0' } },
          axisLabel: { color: '#333' },
          splitLine: { lineStyle: { color: '#f5f5f5' } }
        },
        series: [
          // {
          //   name: '跟进客户数',
          //   type: 'line',
          //   data: [120, 132, 101, 134, 90, 230, 210, 250, 220, 180, 160, 190],
          //   lineStyle: { color: '#67C23A' },
          //   itemStyle: { color: '#67C23A' },
          //   areaStyle: { color: 'rgba(103, 194, 58, 0.1)' }
          // },
          // {
          //   name: '成交客户数',
          //   type: 'line',
          //   data: [40, 62, 31, 54, 20, 80, 70, 100, 80, 60, 50, 70],
          //   lineStyle: { color: '#409EFF' },
          //   itemStyle: { color: '#409EFF' },
          //   areaStyle: { color: 'rgba(64, 158, 255, 0.1)' }
          // }
        ]
      });
      this.trendChart.resize({ width: trendContainer.offsetWidth - 30, height: 280 });

      // 3. 本月业务进度饼图
      this.businessChart = echarts.init(document.getElementById('businessChart'));
      this.businessChart.setOption({
        backgroundColor: '#fff',
        tooltip: { trigger: 'item', formatter: '{b}: {d}%' },
        series: [{
          name: '业务进度',
          type: 'pie',
          radius: ['20%', '50%'],
          center: ['50%', '50%'],
          data: [
            { value: 65, name: '已完成', itemStyle: { color: '#67C23A' } },
            { value: 20, name: '进行中', itemStyle: { color: '#409EFF' } },
            { value: 15, name: '未开始', itemStyle: { color: '#E6A23C' } }
          ],
          label: { show: true, color: '#333', formatter: '{b}\n{d}%' }
        }]
      });

      // 4. 客户等级分布柱状图
      this.levelChart = echarts.init(document.getElementById('levelChart'));
      this.levelChart.setOption({
        backgroundColor: '#fff',
        tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' } },
        grid: { left: '10%', right: '10%', bottom: '5%', top: '20%', containLabel: true },
        xAxis: {
          type: 'category',
          data: ['优质客户', '高级客户', '中级客户', '低级客户', '垃圾客户'],
          axisLine: { lineStyle: { color: '#e0e0e0' } },
          axisLabel: { color: '#333' }
        },
        yAxis: {
          type: 'value',
          axisLine: { lineStyle: { color: '#e0e0e0' } },
          axisLabel: { color: '#333' },
          splitLine: { lineStyle: { color: '#f5f5f5' } }
        },
        series: [{
          name: '客户数',
          type: 'bar',
          data: [23, 156, 897, 210],
          itemStyle: {
            color: (params) => {
              const colors = ['#67C23A', '#409EFF', '#E6A23C', '#F56C6C'];
              return colors[params.dataIndex];
            }
          },
          barWidth: '40%'
        }]
      });
    }
  }
};
</script>

<style scoped>
/* 全局容器：严格约束，无溢出 */
.dashboard-container {
  width: 100%;
  min-height: 100vh;
  background-color: #f5f5f5;
  padding: 15px;
  padding-bottom: 70px;
  box-sizing: border-box;
  font-family: "Microsoft YaHei", Arial, sans-serif;
  color: #333;
  overflow-y: auto;
  max-width: 100vw;
  /* 禁止超出视口宽度 */
}

/* 头部 */
.dashboard-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  margin-bottom: 20px;
  max-width: 100%;
  box-sizing: border-box;
}

.title-box h1 {
  font-size: 22px;
  color: #000;
  margin: 0 0 5px 0;
}

.title-box p {
  font-size: 12px;
  color: #666;
  margin: 0;
}

.refresh-btn {
  background-color: #67C23A;
  color: #fff;
  border: none;
  border-radius: 4px;
  padding: 6px 12px;
  font-size: 12px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.refresh-btn:hover {
  background-color: #5cad32;
}

/* 核心卡片 */
.core-card-wrapper {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 15px;
  margin-bottom: 20px;
  box-sizing: border-box;
  max-width: 100%;
  overflow: hidden;
}

.core-card {
  background-color: #fff;
  border-radius: 8px;
  padding: 15px;
  display: flex;
  align-items: center;
  gap: 15px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  box-sizing: border-box;
  max-width: 100%;
}

.card-icon {
  width: 48px;
  height: 48px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 20px;
}

.card-content h4 {
  font-size: 13px;
  color: #666;
  margin: 0 0 8px 0;
}

.card-number {
  font-size: 24px;
  font-weight: 600;
  color: #000;
  margin: 0 0 5px 0;
}

.card-change.up {
  color: #67C23A;
}

.card-change.down {
  color: #F56C6C;
}

/* 双图表区域：彻底禁止溢出 */
.double-chart-wrapper {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 15px;
  margin-bottom: 20px;
  width: 100%;
  box-sizing: border-box;
  max-width: 100%;
  overflow: hidden;
}

.chart-box {
  background-color: #fff;
  border-radius: 8px;
  padding: 15px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  width: 100%;
  box-sizing: border-box;
  max-width: 100%;
  overflow: hidden;
}

.chart-box h3 {
  font-size: 15px;
  color: #000;
  margin: 0 0 10px 0;
}

/* 图表容器：严格约束尺寸，减去内边距避免溢出 */
.chart-container {
  width: 100%;
  height: 280px;
  box-sizing: border-box;
  padding: 0;
  margin: 0;
  overflow: hidden;
}

.chart-content {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
}

/* 日程组件：星期与日期严格对齐 */
.schedule-wrapper {
  background-color: #fff;
  border-radius: 8px;
  padding: 15px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  margin-bottom: 20px;
  box-sizing: border-box;
  max-width: 100%;
  overflow: hidden;
}

.schedule-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.schedule-header h3 {
  font-size: 15px;
  color: #000;
  margin: 0;
}

.date-picker {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 12px;
}

.date-picker button {
  background-color: #f0f0f0;
  border: none;
  border-radius: 4px;
  padding: 4px 8px;
  cursor: pointer;
  font-size: 11px;
  transition: background-color 0.2s;
}

.date-picker button:hover {
  background-color: #e5e5e5;
}

.date-range-text {
  color: #666;
}

.calendar-header {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 5px;
  margin-bottom: 10px;
  max-width: 100%;
  overflow: hidden;
}

.calendar-day {
  text-align: center;
  font-size: 12px;
  color: #666;
  padding: 8px 0;
  background-color: #f9f9f9;
  border-radius: 4px;
}

.calendar-content {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 5px;
  height: fit-content;
  max-width: 100%;
  overflow: hidden;
}

.calendar-column {
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  overflow: hidden;
}

/* 日历日期：适配完整格式，无挤压 */
.calendar-date {
  text-align: center;
  font-size: 10px;
  padding: 6px 0;
  margin-bottom: 5px;
  border-radius: 4px;
  background-color: #f0f0f0;
  color: #333;
  word-break: keep-all;
}

.calendar-date.active {
  background-color: #67C23A;
  color: #fff;
}

.schedule-item {
  background-color: #f9f9f9;
  border-radius: 4px;
  padding: 8px;
  margin-bottom: 5px;
  font-size: 11px;
  border: 1px solid #e0e0e0;
  box-sizing: border-box;
  overflow: hidden;
  cursor: pointer;
  transition: .3s;
}

.schedule-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.item-order {
  font-weight: 600;
  color: #000;
  margin-bottom: 3px;
}

.item-person {
  display: flex;
  justify-content: space-between;
  color: #666;
  margin-bottom: 3px;
}

.item-content {
  color: #333;
  margin-bottom: 3px;
  line-height: 1.3;
}

.item-time {
  color: #999;
  text-align: right;
}

/* 横向并排容器：无溢出 */
.horizontal-combo-wrapper {
  display: flex;
  gap: 15px;
  width: 100%;
  margin-bottom: 20px;
  box-sizing: border-box;
  max-width: 100%;
  overflow: hidden;
}

/* 新增：辅助卡片容器样式（和原订单面板保持一致） */
.assist-card-wrapper {
  background-color: #fff;
  border-radius: 8px;
  padding: 15px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  flex: 1;
  box-sizing: border-box;
  max-height: 520px;
  max-width: 50%;
}

.assist-card-wrapper h3 {
  font-size: 15px;
  color: #000;
  margin: 0 0 10px 0;
}

/* 最新订单（移位置后样式适配） */
.latest-order-wrapper {
  height: 500px;
  overflow-y: auto;
  flex: 1;
  box-sizing: border-box;
  max-width: 100%;
}

.latest-order-wrapper h3 {
  font-size: 15px;
  color: #000;
  margin: 0 0 10px 0;
}

.order-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.order-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  background-color: #f9f9f9;
  border-radius: 4px;
  border: 1px solid #e0e0e0;
  box-sizing: border-box;
  cursor: pointer;
  transition: .3s;
}

.order-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}



.order-left {
  flex: 2;
}

.order-no {
  font-size: 13px;
  font-weight: 600;
  color: #000;
  margin-bottom: 5px;
}

.order-base {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  font-size: 11px;
  color: #666;
}

.order-right {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.order-progress {
  width: 150px;
  margin-bottom: 5px;
}

.progress-bg {
  width: 100%;
  height: 6px;
  background-color: #e0e0e0;
  border-radius: 3px;
  overflow: hidden;
  margin-bottom: 3px;
}

.progress-fill {
  height: 100%;
  border-radius: 3px;
  transition: width 0.3s;
}

.progress-text {
  font-size: 11px;
  color: #666;
}

.order-update {
  font-size: 11px;
  color: #999;
}

/* 业务进度 */
.business-progress-wrapper {
  background-color: #fff;
  border-radius: 8px;
  padding: 15px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  flex: 1;
  box-sizing: border-box;
  max-height: 520px;
  display: flex;
  flex-direction: column;
  max-width: 50%;
}

.business-progress-wrapper h3 {
  font-size: 15px;
  color: #000;
  margin: 0 0 10px 0;
}

.business-chart-box {
  display: flex;
  align-items: center;
  gap: 20px;
  height: 280px;
  flex: 1;
}

.business-chart-content {
  width: 60%;
  height: 100%;
  box-sizing: border-box;
}

.business-desc {
  width: 40%;
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.desc-item {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 13px;
}

.desc-color {
  width: 16px;
  height: 16px;
  border-radius: 4px;
}

.desc-name {
  width: 80px;
  color: #333;
}

.desc-value {
  color: #666;
}

/* 其他数据 */
.other-data-wrapper {
  background-color: #fff;
  border-radius: 8px;
  padding: 15px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  box-sizing: border-box;
  max-width: 100%;
  overflow: hidden;
}

.other-data-wrapper h3 {
  font-size: 15px;
  color: #000;
  margin: 0 0 10px 0;
}

.data-panel {
  display: flex;
  gap: 15px;
  max-width: 100%;
  overflow: hidden;
}

/* 辅助卡片原样式保留 */
.panel-left {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
  max-width: 100%;
  overflow: hidden;
}

.assist-card {
  background-color: #f9f9f9;
  border-radius: 4px;
  padding: 10px;
  border: 1px solid #e0e0e0;
  box-sizing: border-box;
  max-width: 100%;
}

.assist-card h4 {
  font-size: 12px;
  color: #666;
  margin: 0 0 5px 0;
}

.assist-value {
  font-size: 18px;
  font-weight: 600;
  color: #000;
  margin: 0 0 3px 0;
}

.assist-change.positive {
  color: #67C23A;
}

.assist-change.negative {
  color: #F56C6C;
}

.panel-right {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-width: 100%;
  overflow: hidden;
}

/* 待办事项：默认今日，支持日期筛选 */
.todo-list {
  background-color: #f9f9f9;
  border-radius: 4px;
  padding: 15px;
  border: 1px solid #e0e0e0;
  flex: 1;
  box-sizing: border-box;
  max-width: 100%;
  overflow-y: auto;
  max-height: 250px;
}

.todo-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.todo-top h4 {
  font-size: 13px;
  color: #000;
  margin: 0;
}

.todo-date-picker {
  width: 140px;
}

.todo-list ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.todo-list li {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 0;
  border-bottom: 1px solid #e5e5e5;
  font-size: 12px;
}

.todo-content.completed {
  text-decoration: line-through;
  color: #999;
}

.todo-deadline {
  font-size: 10px;
  color: #F56C6C;
  margin-left: auto;
}

/* 无待办提示 */
.no-todo-tip {
  text-align: center;
  color: #999;
  border-bottom: none !important;
}

/* 客户等级分布 */
.customer-level {
  background-color: #f9f9f9;
  border-radius: 4px;
  padding: 15px;
  border: 1px solid #e0e0e0;
  flex: 1;
  box-sizing: border-box;
  max-width: 100%;
}

.customer-level h4 {
  font-size: 13px;
  color: #000;
  margin: 0 0 10px 0;
}

.level-chart-content {
  width: 100%;
  height: 180px;
  box-sizing: border-box;
}

.other-data-wrapper-btn {
  margin-right: calc(50% + 15px);
  font-size: 14px;
  cursor: pointer;
}

/* 响应式：小屏幕下纵向布局，无溢出 */
@media (max-width: 992px) {
  .core-card-wrapper {
    grid-template-columns: repeat(2, 1fr);
  }

  .other-data-wrapper-btn {
    margin-right: 5px;
  }

  .double-chart-wrapper {
    grid-template-columns: 1fr;
  }

  .horizontal-combo-wrapper {
    flex-direction: column;
  }

  .assist-card-wrapper,
  .business-progress-wrapper {
    max-width: 100%;
  }

  .data-panel {
    flex-direction: column;
  }
}

@media (max-width: 576px) {
  .core-card-wrapper {
    grid-template-columns: 1fr;
  }

  .panel-left {
    grid-template-columns: 1fr;
  }
}
</style>